<template>
  <teleport to="body">
    <div class="dialog">
      <div class="dialog__layout">
        <div
          v-if="title"
          class="typo-title"
        >
          <strong>{{ title }}</strong>
        </div>
        <!-- Dialog content -->
        <div
          v-if="message"
          class="dialog__content"
        >
          {{ message }}
        </div>
        <slot />

        <!-- Dialog actions -->
        <div class="dialog__actions">
          <button
            class="button"
            type="button"
            @click="dismissDialog"
          >
            {{ $t('general.cancel') }}
          </button>
          <slot name="actions" />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
defineProps({
  title: { type: String, required: false, default: null },
  message: { type: String, required: false, default: null },
});
const emit = defineEmits(['dismissDialog']);

function dismissDialog() {
  emit('dismissDialog');
}
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.dialog {
  align-items: flex-start;
  background-color: rgba(map-get($background-color, dark), 0.88);
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1093; // higher than leaflet and the header bar
  overflow-y: scroll;

  @include breakpoint(medium) {
    align-items: center;
  }

  &__layout {
    background-color: map-get($background-color, lighter);
    box-shadow: map-get($box-shadow, popover);
    width: 100%;
    padding: bu(4) bu(3) bu(4.5) bu(3);

    @include breakpoint(medium) {
      border-radius: map-get($border-radius, mega-heavy);
      padding: bu(4.5) bu(7) bu(4.5) bu(7);
      width: rem(500);
    }
  }

  &__content {
    padding-top: bu(2);
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: right;
    padding-top: bu(4);
  }
}
</style>
